import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LanguageService } from '../services/language.service';
import { AuthService } from '../services/auth.service';

export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  const languageService = inject(LanguageService);
  const authService = inject(AuthService);

  const currentLanguage = languageService.getCurrentLanguage();
  const token = authService.getToken();

  // Only set Accept-Language if not already set manually on the request
  let headers = req.headers.has('Accept-Language')
    ? req.headers
    : req.headers.set('Accept-Language', currentLanguage);

  if (token && authService.shouldAttachAuthHeader(req.url)) {
    headers = headers.set('Authorization', `Bearer ${token}`);
  }

  const clonedRequest = req.clone({ headers });

  return next(clonedRequest);
};
